import { useQuery } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { useProgramBroadcastFilters } from '@/stores/program-broadcast-filters';

import type { TInformationUnitTag } from '../types';

type TGetTags = {
  tagSearch: string;
  workspaces: string[];
  clients: string[];
};

export async function getInformationUnitTags({
  workspaces,
  clients,
  tagSearch,
}: TGetTags): Promise<TInformationUnitTag[]> {
  return acceso360Client
    .get(`/monitoring/api/v1/information_unit_tags`, {
      params: {
        limit: 25,
        ...(workspaces && workspaces.length > 0 && { workspace_id__in: workspaces.join(',') }),
        ...(clients && clients.length > 0 && { client_id__in: clients.join(',') }),
        ...(tagSearch && { search: tagSearch }),
      },
    })
    .then(({ data }) => data);
}

type QueryFnType = typeof getInformationUnitTags;

interface UseInformationUnitTagsParams {
  config?: QueryConfig<QueryFnType>;
}

export function useInformationUnitTags({ config = {} }: UseInformationUnitTagsParams = {}) {
  const { workspaces, clients, tagSearch } = useProgramBroadcastFilters();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['information_unit_tags', { workspaces, clients, tagSearch }],
    queryFn() {
      return getInformationUnitTags({ workspaces, clients, tagSearch });
    },
  });
}
